<script setup>

defineProps({
    title: {
        type: String,
        required: false
    }
});

</script>

<template>
    <div class="container-card">
        <h2
            v-if="title"
            class="mb-[16px] text-[28px] font-[300]"
        >
            {{ title }}
        </h2>

        <slot />
    </div>
</template>

<style scoped>
.container-card {
    padding: 1rem;
    border: 1px solid #d9d9d9;
    border-radius: 0.5rem;
    background-color: #ffffff ;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

}

</style>
